import { AffiliateApi } from "@/api/affiliates";
import { Affiliate } from "@/types";
import { QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";
import { useNotify, useRedirect } from "react-admin";

export const useGetAffiliatePaymentPeriods = (affiliateId: Affiliate["id"]) => {
  const redirect = useRedirect();
  const notify = useNotify();

  const { data, isPending, isError, error } = useQuery({
    queryKey: [QueryKey.AFFILIATE_PAYMENT_PERIODS, affiliateId],
    queryFn: () => AffiliateApi.getAffiliatePaymentPeriods({ affiliateId }),
    enabled: !!affiliateId,
  });

  if (isError) {
    notify(error, { type: "error" });
    redirect("list");
  }

  return {
    paymentPeriods: data || {
      unpaidPeriods: [],
      paidPeriods: [],
    },
    isPaymentPeriodsLoading: isPending,
  };
};
